(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function filterDescriptions() {
      var hash = window.location.hash.slice(1);
      var section = document.querySelector('.collection-description');
      if (!section) return;
      var blocks = section.querySelectorAll('.cd__sport');
      if (!blocks.length) return;

      var matched = false;
      if (hash) {
        blocks.forEach(function (b) {
          if (b.id === 'cd-' + hash) {
            b.style.display = 'block';
            matched = true;
          } else {
            b.style.display = 'none';
          }
        });
      }

      if (!matched) {
        blocks.forEach(function (b, i) {
          b.style.display = i === 0 ? 'block' : 'none';
        });
      }
    }

    document.addEventListener('DOMContentLoaded', filterDescriptions);
    window.addEventListener('hashchange', filterDescriptions);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-faq-root]');
    if (!root) return;
    var links = root.querySelectorAll('[data-faq-scroll]');
    if (!links.length) return;
    var anchors = root.querySelectorAll('[data-faq-anchor]');

    // Smooth scroll on click + set active state
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = link.getAttribute('data-faq-scroll');
        var el = root.querySelector('#' + CSS.escape(target));
        if (!el) return;
        var y = el.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
        setActive(target);
      });
    });

    function setActive(anchor) {
      links.forEach(function (l) {
        l.classList.toggle('is-active', l.getAttribute('data-faq-scroll') === anchor);
      });
    }

    // Scroll spy — highlight sidebar link for the heading closest to
    // the top of the viewport. IntersectionObserver keeps it cheap.
    if ('IntersectionObserver' in window && anchors.length) {
      var visible = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var id = entry.target.getAttribute('data-faq-anchor');
          if (entry.isIntersecting) visible[id] = entry.intersectionRatio;
          else delete visible[id];
        });
        // pick topmost visible
        var topId = null, topY = Infinity;
        Object.keys(visible).forEach(function (id) {
          var el = root.querySelector('#' + CSS.escape(id));
          if (!el) return;
          var y = el.getBoundingClientRect().top;
          if (y < topY) { topY = y; topId = id; }
        });
        if (topId) setActive(topId);
      }, {
        rootMargin: '-80px 0px -60% 0px',
        threshold: [0, 0.25, 0.5, 1]
      });
      anchors.forEach(function (a) { io.observe(a); });
    }

    // ── Tab cards (Bulk / Online) ──────────────────────────────
    var tabCards = document.querySelectorAll('[data-faq-tab]');
    if (!tabCards.length) return;
    var sectionEls = root.querySelectorAll('[data-faq-sec]');

    // The sidebar wrapper — hide it entirely until a tab is chosen so the
    // layout shows just the tab cards on load.
    var sidebarEl = root.querySelector('.faq__sidebar');

    function setActiveSection(secId) {
      tabCards.forEach(function (c) {
        var active = c.getAttribute('data-faq-tab') === secId;
        c.classList.toggle('faq__tab-card--active', active);
        c.setAttribute('aria-selected', String(active));
      });
      sectionEls.forEach(function (el) {
        var sec = el.getAttribute('data-faq-sec');
        // When no section is active (secId === null), hide EVERYTHING that
        // belongs to a section. Un-tagged elements always show.
        var show = secId ? (sec === secId || !sec) : !sec;
        el.classList.toggle('faq__hidden-by-tab', !show);
        if (el.tagName === 'DETAILS' && !show) el.removeAttribute('open');
      });
      if (sidebarEl) {
        sidebarEl.classList.toggle('faq__hidden-by-tab', !secId);
      }
      root.classList.toggle('faq__layout--no-active', !secId);
    }

    tabCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var target = card.getAttribute('data-faq-tab');
        var alreadyActive = card.classList.contains('faq__tab-card--active');
        if (alreadyActive) {
          // Second click on the active tab → collapse back to hidden state.
          setActiveSection(null);
          return;
        }
        setActiveSection(target);
        // Smooth scroll to bring the newly-shown FAQ list into view.
        requestAnimationFrame(function () {
          var y = root.getBoundingClientRect().top + window.pageYOffset - 20;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
    });

    // Initialise: NO tab active on load — everything section-scoped is hidden
    // until the user clicks a card.
    setActiveSection(null);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grg-store-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var PER_PAGE = 10;

  var sectionEl = document.querySelector('.grg-store-products');
  if (!sectionEl) return;

  var fixedCategory = (sectionEl.dataset.fixedCategory || '').trim().toLowerCase();
  var state = { category: fixedCategory, sort: 'featured', page: 1 };

  var grid = sectionEl.querySelector('#gsp-grid');
  if (!grid) return;

  var allCards = Array.from(grid.querySelectorAll('.gsp-card'));
  var noResults = sectionEl.querySelector('#gsp-no-results');
  var paginationNav = sectionEl.querySelector('#gsp-pagination');

  /* ── Filter + sort ── */
  function getVisible() {
    return allCards
      .filter(function (c) {
        return !state.category || c.dataset.category.toLowerCase() === state.category.toLowerCase();
      })
      .sort(function (a, b) {
        switch (state.sort) {
          case 'price-asc':  return Number(a.dataset.price) - Number(b.dataset.price);
          case 'price-desc': return Number(b.dataset.price) - Number(a.dataset.price);
          case 'title-asc':  return (a.dataset.title || '').localeCompare(b.dataset.title || '');
          case 'title-desc': return (b.dataset.title || '').localeCompare(a.dataset.title || '');
          default:           return Number(a.dataset.order) - Number(b.dataset.order);
        }
      });
  }

  /* ── Render ── */
  function render() {
    var visible = getVisible();
    var totalPages = Math.max(1, Math.ceil(visible.length / PER_PAGE));

    if (state.page > totalPages) state.page = 1;

    var start = (state.page - 1) * PER_PAGE;
    var pageItems = visible.slice(start, start + PER_PAGE);

    allCards.forEach(function (c) { c.classList.add('gsp-card--hidden'); });
    pageItems.forEach(function (c) { c.classList.remove('gsp-card--hidden'); });

    if (noResults) {
      if (visible.length > 0) {
        noResults.classList.add('gsp-card--hidden');
      } else {
        noResults.classList.remove('gsp-card--hidden');
      }
    }
    if (paginationNav) buildPagination(totalPages);
  }

  /* ── Pagination DOM ── */
  function buildPagination(totalPages) {
    paginationNav.innerHTML = '';
    if (totalPages <= 1) return;

    var ul = document.createElement('ul');
    ul.className = 'gsp-pagination__list';

    ul.appendChild(makeNavBtn('\u2190', state.page === 1, function () {
      state.page--;
      render();
      scrollToSection();
    }, 'Previous page', 'gsp-pagination__prev'));

    for (var i = 1; i <= totalPages; i++) {
      (function (p) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gsp-pagination__btn gsp-pagination__page' +
          (p === state.page ? ' gsp-pagination__page--active' : '');
        btn.textContent = p;
        btn.setAttribute('aria-label', 'Page ' + p);
        if (p === state.page) btn.setAttribute('aria-current', 'page');
        btn.addEventListener('click', function () { state.page = p; render(); scrollToSection(); });
        li.appendChild(btn);
        ul.appendChild(li);
      })(i);
    }

    ul.appendChild(makeNavBtn('\u2192', state.page === totalPages, function () {
      state.page++;
      render();
      scrollToSection();
    }, 'Next page', 'gsp-pagination__next'));

    paginationNav.appendChild(ul);
  }

  function makeNavBtn(html, disabled, onClick, label, cls) {
    var li = document.createElement('li');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gsp-pagination__btn ' + cls;
    btn.innerHTML = html;
    btn.disabled = disabled;
    btn.setAttribute('aria-label', label);
    if (!disabled) btn.addEventListener('click', onClick);
    li.appendChild(btn);
    return li;
  }

  function scrollToSection() {
    sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Dropdowns ── */
  function initDropdowns() {
    sectionEl.querySelectorAll('[data-dropdown]').forEach(function (wrap) {
      var key   = wrap.dataset.dropdown;
      var btn   = wrap.querySelector('[data-dropdown-btn="' + key + '"]');
      var menu  = wrap.querySelector('[data-dropdown-menu="' + key + '"]');
      var valEl = wrap.querySelector('[data-dropdown-value="' + key + '"]');
      if (!btn || !menu) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = !menu.classList.contains('gsp__menu--closed');
        closeAll();
        if (!wasOpen) {
          menu.classList.remove('gsp__menu--closed');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      menu.querySelectorAll('.gsp__option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          menu.querySelectorAll('.gsp__option').forEach(function (o) {
            o.classList.remove('gsp__option--active');
          });
          opt.classList.add('gsp__option--active');
          if (valEl) valEl.textContent = opt.textContent.trim();
          menu.classList.add('gsp__menu--closed');
          btn.setAttribute('aria-expanded', 'false');

          if (key === 'category') {
            state.category = opt.dataset.category || '';
          } else if (key === 'sort') {
            state.sort = opt.dataset.sort || 'featured';
          }
          state.page = 1;
          render();
        });

        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); }
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-dropdown]')) closeAll();
    });
  }

  function closeAll() {
    sectionEl.querySelectorAll('[data-dropdown-menu]').forEach(function (m) { m.classList.add('gsp__menu--closed'); });
    sectionEl.querySelectorAll('[data-dropdown-btn]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  /* ── Cart add ── */
  grid.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('.gsp-card__cart-btn');
    if (!cartBtn) return;
    e.preventDefault();
    e.stopPropagation();

    // Ordering window closed → never add to cart (mirrors the PDP gate).
    if (cartBtn.disabled || cartBtn.dataset.closed === 'true') return;

    var variantId = cartBtn.dataset.variantId;
    if (!variantId || variantId === 'nil') return;

    cartBtn.disabled = true;
    cartBtn.classList.add('gsp-card__cart-btn--adding');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        cartBtn.classList.remove('gsp-card__cart-btn--adding');
        cartBtn.classList.add('gsp-card__cart-btn--added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          cartBtn.disabled = false;
          cartBtn.classList.remove('gsp-card__cart-btn--added');
        }, 1500);
      })
      .catch(function () {
        cartBtn.disabled = false;
        cartBtn.classList.remove('gsp-card__cart-btn--adding');
      });
  });

  /* ── Init ── */
  initDropdowns();
  render();
})();




// ── Auto-scroll interval store ──
(function () {
  const gspTimers = new WeakMap();

  function gspCarouselMove(carousel, dir) {
    const slides = carousel.querySelectorAll('.gsp-carousel__slide');
    const dots   = carousel.querySelectorAll('.gsp-carousel__dot');
    const total  = slides.length;
    if (total < 1) return;

    let idx = parseInt(carousel.dataset.index, 10) || 0;
    idx = (idx + dir + total) % total;

    carousel.dataset.index = idx;
    carousel.querySelector('.gsp-carousel__track').style.transform =
      `translateX(-${idx * 100}%)`;

    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
  }

  function gspStartAuto(carousel) {
    if (carousel.querySelectorAll('.gsp-carousel__slide').length < 2) return;
    const timer = setInterval(() => gspCarouselMove(carousel, 1), 2000);
    gspTimers.set(carousel, timer);
  }

  function gspStopAuto(carousel) {
    clearInterval(gspTimers.get(carousel));
    gspTimers.delete(carousel);
  }

  function gspInitCarousel(carousel) {
    carousel.querySelectorAll('.gsp-carousel__btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const dir = btn.classList.contains('gsp-carousel__btn--prev') ? -1 : 1;
        gspCarouselMove(carousel, dir);
      });
    });

    gspStartAuto(carousel);
    carousel.addEventListener('mouseenter', () => gspStopAuto(carousel));
    carousel.addEventListener('mouseleave', () => gspStartAuto(carousel));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.gsp-carousel').forEach(gspInitCarousel);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  class HowItWorksVideo extends HTMLElement {
    connectedCallback() {
      this.playBtn = this.querySelector('.how-it-works__play-btn');
      this.modal = this.querySelector('.how-it-works__modal');
      this.closeBtn = this.querySelector('.how-it-works__modal-close');
      this.backdrop = this.querySelector('.how-it-works__modal-backdrop');
      this.iframe = this.querySelector('.how-it-works__iframe');
      this.video = this.querySelector('.how-it-works__video');

      if (!this.playBtn || !this.modal) return;

      // Source precedence: raw MP4 URL → uploaded video file → URL
      this.videoMp4Url = this.playBtn.dataset.videoMp4Url;
      this.videoFile = this.playBtn.dataset.videoFile;
      this.videoUrl = this.playBtn.dataset.videoUrl;

      this.playBtn.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.backdrop) this.backdrop.addEventListener('click', () => this.close());

      this.modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    getEmbedUrl(url) {
      const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]+)/);
      if (ytMatch) {
        return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
      }
      const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
      if (vimeoMatch) {
        return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
      }
      return url;
    }

    open() {
      if (this.video && (this.videoMp4Url || this.videoFile)) {
        // Native <video> path — MP4 URL or Shopify Video file
        try { this.video.currentTime = 0; } catch (_) {}
        this.video.play().catch(function () { /* autoplay blocked — user can press play */ });
      } else if (this.iframe && this.videoUrl) {
        // YouTube / Vimeo iframe path
        this.iframe.src = this.getEmbedUrl(this.videoUrl);
      } else {
        return;
      }
      this.modal.showModal();
      document.body.style.overflow = 'hidden';
    }

    close() {
      if (this.video) {
        try { this.video.pause(); } catch (_) {}
      }
      if (this.iframe) this.iframe.src = '';
      this.modal.close();
      document.body.style.overflow = '';
    }
  }

  if (!customElements.get('how-it-works-video')) {
    customElements.define('how-it-works-video', HowItWorksVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-sport-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function filterSports() {
      var hash = window.location.hash.slice(1);
      var section = document.querySelector('.page-sport-collection');
      if (!section) return;
      var blocks = section.querySelectorAll('.psc__sport');
      if (!blocks.length) return;

      var matched = false;
      if (hash) {
        blocks.forEach(function (b) {
          if (b.id === hash) {
            b.style.display = 'block';
            matched = true;
          } else {
            b.style.display = 'none';
          }
        });
      }

      /* No hash or no match — show first sport only */
      if (!matched) {
        blocks.forEach(function (b, i) {
          b.style.display = i === 0 ? 'block' : 'none';
        });
      }
    }

    document.addEventListener('DOMContentLoaded', filterSports);
    window.addEventListener('hashchange', filterSports);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-showcase"] && !Shopify.designMode) return;
  try {
    
  class TabbedShowcase extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('.tabbed-showcase__tab');
      this.panels = this.querySelectorAll('.tabbed-showcase__panel');

      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchTab(tab));
      });
    }

    switchTab(selectedTab) {
      const index = selectedTab.dataset.tabIndex;

      this.tabs.forEach(tab => {
        const isActive = tab.dataset.tabIndex === index;
        tab.classList.toggle('tabbed-showcase__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach(panel => {
        const isActive = panel.dataset.panelIndex === index;
        panel.classList.toggle('tabbed-showcase__panel--active', isActive);
      });
    }
  }

  if (!customElements.get('tabbed-showcase')) {
    customElements.define('tabbed-showcase', TabbedShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teamwear-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var links = document.querySelectorAll('.twc__nav-link[data-target]');
    if (!links.length) return;

    var sections = Array.from(links).map(function (link) {
      return document.getElementById(link.dataset.target);
    }).filter(Boolean);

    function setActive(id) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.target === id);
      });
    }

    /* Set first active on load */
    if (sections.length) setActive(sections[0].id);

    /* Update on hash change */
    window.addEventListener('hashchange', function () {
      var hash = window.location.hash.slice(1);
      if (hash) setActive(hash);
    });

    /* Update on scroll via IntersectionObserver */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

      sections.forEach(function (sec) { observer.observe(sec); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
